define('underscoreTemplates',["jquery", "underscore"], function ($, _) {
    "use strict";

    function UnderscoreTemplates() { }

    UnderscoreTemplates.prototype.renderTemplate = function renderTemplate($target, $template, data) {
        var tmpl = _.template($template);
        $target.html(tmpl(data));
    }

    return new UnderscoreTemplates();
});
